import React from "react";
import { Form, Row, Col, Select } from "antd";
import FormSection from "../../components/Backoffice/FormSection";
import { addressToString } from "../../utils/formatter";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";
import ControlledTransfer from "../../components/Backoffice/ControlledTransfer";

const { Option } = Select;

const AddUserForm = ({
  control,
  pickupAddress,
  billingAddress,
  errors,
  edit = false,
  handleRoleSelect,
}) => {
  const pickupAddressData = pickupAddress?.map((addr) => ({
    key: addr._id,
    title: addressToString(addr),
  }));

  const billingAddressData = billingAddress?.map((addr) => ({
    key: addr._id,
    title: addressToString(addr),
  }));

  const getRoleOptions = (stateId) => {
    const opts = [];
    let roles = [
      { id: 1, value: "company_user", name: "Company User" },
      { id: 2, value: "company_admin", name: "Company Admin" },
    ];

    roles.forEach((role) => {
      opts.push(
        <Option key={role.id} value={role.value}>
          {role.name}
        </Option>
      );
    });
    return opts;
  };

  return (
    <Form colon={false}>
      <FormSection heading="Basic Information">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="firstName"
              label="First Name"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              required
              name="lastName"
              label="Last Name"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              control={control}
              name="department"
              label="Department"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              name="designation"
              label="Designation"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="email"
              label="Email"
              errors={errors}
              disabled={edit}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              required
              disabled={edit}
              name="phone"
              label="Contact"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              control={control}
              name="alternateContact"
              label="Alternate Contact"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledSelect
              control={control}
              options={getRoleOptions()}
              customChange={handleRoleSelect}
              required
              name="role"
              label="User Role"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      <FormSection heading={"Pickup Address Association"}>
        <ControlledTransfer
          required
          control={control}
          name="pickupAddress"
          data={pickupAddressData}
          errors={errors}
        />
      </FormSection>
      <FormSection heading={"Billing Address Association"}>
        <ControlledTransfer
          required
          control={control}
          name="billingAddress"
          data={billingAddressData}
          errors={errors}
        />
      </FormSection>
    </Form>
  );
};

export default AddUserForm;
